var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Edit = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, props),
        React.createElement("defs", null,
            React.createElement("path", { id: "a", d: "M0 0h19.444v19.435H0z" })),
        React.createElement("g", { fill: "none" },
            React.createElement("mask", { id: "b", fill: "#fff" },
                React.createElement("use", null)),
            React.createElement("path", { fill: color, d: "M6.66 14.953l-2.186-2.187 11.69-11.691 2.201 2.199L6.66 14.953zm-2.845-1.431l2.114 2.114-2.89 1.419-.638-.678 1.414-2.855zM19.212 2.708L16.733.228a.82.82 0 0 0-1.137 0L3.087 12.74l-3.05 6.157a.374.374 0 1 0 .502.499l6.072-2.981 12.6-12.571a.808.808 0 0 0 .001-1.136z" }))));
};
Edit.defaultProps = {
    color: '#333',
};
export default Edit;
//# sourceMappingURL=Edit.js.map